export default __webpack_public_path__ + "static/media/portfolio.058fc027.PNG";